export const CONTROL_TYPES = ["preventative", "detective", "corrective", "directive"];

export const CONTROL_TYPE_META = {
  preventative: { label: "Preventative", tone: "bg-green-50 text-green-700 border-green-300", help: "Stops a failure before it happens (e.g. access restrictions, approvals)." },
  detective: { label: "Detective", tone: "bg-blue-50 text-blue-700 border-blue-300", help: "Catches a failure that has occurred (e.g. monitoring, reconciliations, log review)." },
  corrective: { label: "Corrective", tone: "bg-amber-50 text-amber-700 border-amber-300", help: "Fixes or remediates after a failure is detected (e.g. remediation plan)." },
  directive: { label: "Directive", tone: "bg-purple-50 text-purple-700 border-purple-300", help: "Policy/guidance that directs correct behavior (e.g. SOP, standard, training)." },
};

export const OPERATING_STATUS = {
  designed: "Designed",
  implemented: "Implemented",
  operating: "Operating",
  not_operating: "Not operating",
};

export const EFFECTIVENESS = {
  effective: "Effective",
  partially_effective: "Partially effective",
  not_tested: "Not tested",
  ineffective: "Ineffective",
};

export const RISK_BAND_META = {
  none: { label: "No Risk", tone: "bg-secondary text-gray-500 border-gray-300" },
  low: { label: "Low", tone: "bg-green-50 text-green-700 border-green-300" },
  medium: { label: "Medium", tone: "bg-yellow-50 text-yellow-700 border-yellow-300" },
  high: { label: "High", tone: "bg-orange-50 text-orange-700 border-orange-400" },
  severe: { label: "Severe", tone: "bg-red-50 text-red-700 border-red-400" },
};

export function ControlTypeBadge({ type }) {
  const m = CONTROL_TYPE_META[type] || CONTROL_TYPE_META.preventative;
  return <span className={`inline-block border px-1.5 py-0.5 text-[11px] font-semibold uppercase rounded-none ${m.tone}`}>{m.label}</span>;
}

export function RiskBandBadge({ band, score, testid }) {
  const m = RISK_BAND_META[band] || RISK_BAND_META.none;
  return <span data-testid={testid} className={`inline-block border px-2 py-0.5 text-[11px] font-bold uppercase rounded-none ${m.tone}`}>{m.label}{typeof score === "number" ? ` · ${score}` : ""}</span>;
}
